











































































































































































































































































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator"
import { Inject } from "inversify-props"
import axios, { CancelTokenSource } from "axios"
import moment from "moment"
import DatePicker from "@/components/ui/DatePicker.vue"
import CampoDeCnpjOuCpf from "@/components/ui/CampoDeCnpjOuCpf.vue"
import SeletorDeLojasDoUsuario from "@/components/loja/SeletorDeLojasDoUsuario.vue"
import SeletorDeGruposEconomicos from "@/components/loja/SeletorDeGruposEconomicos.vue"
import DialogoDePendentesDeDisparo from "./DialogoDePendentesDeDisparo.vue"
import DashboardDaAcaoDeCashback from "./DashboardDaAcaoDeCashback.vue"
import DialogoDeEdicaoDeAcaoDeCashback from "@/components/cashback/DialogoDeEdicaoDeAcaoDeCashback.vue"
import DialogoDeMetaDaAcaoDeCashback from "@/components/cashback/DialogoDeMetaDaAcaoDeCashback.vue"
import { Page, Voucher } from "@/models"
import { GrupoEconomico } from "@/models/GrupoEconomico"
import { AcaoDeCashback } from "@/models/AcaoDeCashback"
import { ResumoDaMetaDeAcaoDeCashback } from "@/models/MetaDeAcaoDeCashback"
import { FindCashbackUseCase, FindImportacaoUseCase, FindLojaUseCase, SaveCashbackUseCase } from "@/usecases"
import type { VoucherServiceAdapter } from "@/usecases"
import Confirmacao from "@/components/ui/Confirmacao.vue"
import AlertModule from "@/store/vuex/aplicacao/AlertModule"
import UserLoginStore from "@/store/vuex/authentication/UserLoginStore"
import { dateToPtBrFormat } from "@/shareds/date/date-utils"
import { aplicarMascaraParaCpfOuCnpjOculto } from "@/shareds/formatadores"
import { obrigatorio } from "@/shareds/regras-de-form"

interface LinhaDeAcao {
	id: string
	name: string
	desc: string
	start: string
	end: string
	type: string
	active: boolean
	used: boolean
}

interface ItemDeCashback {
	gerado: string
	vencimento: string
	valor: number
}

interface ClienteComCashback {
	name: string
	cpf: string
	cpfCompleto: string
	items: ItemDeCashback[]
}

interface ItemDeCashbackPendente {
	name: string
	cpf: string
	gerado: string
	valor: number
}

@Component({
	components: {
		DatePicker,
		CampoDeCnpjOuCpf,
		SeletorDeLojasDoUsuario,
		SeletorDeGruposEconomicos,
		DialogoDePendentesDeDisparo,
		DashboardDaAcaoDeCashback,
		DialogoDeEdicaoDeAcaoDeCashback,
		DialogoDeMetaDaAcaoDeCashback,
		Confirmacao,
	},
})
export default class TelaDeAcoesDeManutencaoDeCashback extends Vue {
	@Ref() dialogoDePendentesDeDisparo!: DialogoDePendentesDeDisparo
	@Ref() dashboardDaAcaoDeCashback!: DashboardDaAcaoDeCashback
	@Ref() dialogoDeEdicaoDeAcaoDeCashback!: DialogoDeEdicaoDeAcaoDeCashback
	@Ref() dialogoDeMetaDaAcaoDeCashback!: DialogoDeMetaDaAcaoDeCashback
	@Ref() confirmacaoExclusao!: Confirmacao
	@Ref() confirmacaoGeracaoPendentes!: Confirmacao

	@Inject('VoucherServiceAdapter')
	private voucherService!: VoucherServiceAdapter

	findCashbackUseCase = new FindCashbackUseCase()
	findImportacaoUseCase = new FindImportacaoUseCase()
	saveCashbackUseCase = new SaveCashbackUseCase()
	findLojaUseCase = new FindLojaUseCase()
	excluindo = false
	exportandoPesquisa = false
	exportandoPrevia = false
	exportandoAgrupado = false
	grupoEconomicoDaLojaId: string | null = null

	filtersOpen = true
	basis = 'expiracao'
	form = { pendentes: false }
	dataInicio: string | null = null
	dataFinal: string | null = null
	cnpjCpfDoCliente = ''
	lojaId: string | null = null
	grupoEconomico: GrupoEconomico | null = null

	carregando = false
	atualizandoCashback = false
	totalRegistros = -1
	paginaClientes = 1
	clientesPorPagina = 10
	listaDeCashback: Voucher[] = []
	cancelToken: CancelTokenSource | null = null

	acoesOpen = true
	carregandoAcoes = false
	acoesDeCashback: AcaoDeCashback[] = []
	search = ''
	type = 'todos'
	tiposDeAcao = [
		{ text: 'Todos os tipos', value: 'todos' },
		{ text: 'Alteração de data', value: 'data' },
		{ text: 'Dobro de Cashback', value: 'dobro' },
	]
	showInactive = false
	grupoEconomicoFiltro: GrupoEconomico | null = null
	selectedId: string | null = null
	paginaAcoes = 1
	acoesPorPagina = 5
	metasPorAcao: Record<string, ResumoDaMetaDeAcaoDeCashback> = {}

	paginaDetalhe: Record<string, number> = {}
	detalheItensPorPagina = 10
	clientesExpandidos: ClienteComCashback[] = []

	obrigatorio = obrigatorio

	TYPE: Record<string, { label: string; icon: string; color: string }> = {
		data:  { label: 'Alteração de data', icon: 'mdi-calendar', color: '#5b8def' },
		dobro: { label: 'Dobro de Cashback', icon: 'mdi-piggy-bank', color: '#e69138' },
	}

	headersAcoes = [
		{ text: '', value: 'type', sortable: false, width: 46 },
		{ text: 'Ação', value: 'name', sortable: false },
		{ text: 'Descrição', value: 'desc', sortable: false },
		{ text: 'Data Início', value: 'start', sortable: false, width: 96 },
		{ text: 'Data Fim', value: 'end', sortable: false, width: 96 },
		{ text: 'Status', value: 'active', sortable: false, align: 'center', width: 80 },
		{ text: 'Meta', value: 'meta', sortable: false, align: 'center', width: 150 },
		{ text: 'Ações', value: 'actions', sortable: false, align: 'end', width: 220 },
	]

	headersClientes = [
		{ text: '', value: 'data-table-expand' },
		{ text: 'Cliente', value: 'name', sortable: false },
		{ text: 'CPF/CNPJ', value: 'cpf', sortable: false },
		{ text: 'Cashbacks', value: 'quantidade', sortable: false, align: 'center' },
		{ text: 'Total R$', value: 'total', sortable: false, align: 'end' },
	]

	mounted() {
		this.carregarAcoes()
	}

	get painelFiltros() {
		return this.filtersOpen ? [0] : []
	}
	set painelFiltros(valor: number[]) {
		this.filtersOpen = valor.length > 0
	}

	get painelAcoes() {
		return this.acoesOpen ? [0] : []
	}
	set painelAcoes(valor: number[]) {
		this.acoesOpen = valor.length > 0
	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao() {
		if (!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	get disableSeletorDeLojas() {
		return !!this.grupoEconomico
	}

	get disableSeletorDeGrupos() {
		return !!this.lojaId
	}

	get deLabel() { return this.basis === 'expiracao' ? 'De (expiração)' : 'De (compra)' }
	get ateLabel() { return this.basis === 'expiracao' ? 'Até (expiração)' : 'Até (compra)' }

	get filtrosDeBuscaPreenchidos(): boolean {
		return !!(this.dataInicio && this.dataFinal && (this.lojaId || this.grupoEconomico))
	}

	mensagemFiltrosObrigatorios = 'Preencha o período (datas) e selecione uma loja ou um grupo econômico para exportar o CSV'

	tituloGeracaoPendentes = 'Confirmar geração de cashbacks pendentes?'
	subtituloGeracaoPendentes = 'Os <strong>cashbacks pendentes de gerar voucher</strong> que se enquadram no filtro terão seus vouchers <strong>gerados imediatamente</strong> (você pode conferi-los no CSV) e a ação selecionada será aplicada sobre eles junto com os demais cashbacks do filtro. Esta ação não poderá ser desfeita. Deseja continuar?'

	get grupoEconomicoAlvoId(): string | null {
		if (this.grupoEconomico) return this.grupoEconomico.id
		if (this.lojaId) return this.grupoEconomicoDaLojaId
		return null
	}

	@Watch('basis')
	onBasisChange(newVal: string) {
		if (newVal !== 'compra') this.form.pendentes = false
	}

	@Watch('lojaId')
	async onLojaChange(newVal: string | null) {
		if (newVal) this.grupoEconomico = null
		await this.carregarGrupoDaLoja()
		this.validarSelecaoAtual()
	}

	@Watch('grupoEconomico')
	onGrupoEconomicoChange(newVal: GrupoEconomico | null) {
		if (newVal) this.lojaId = null
		this.grupoEconomicoDaLojaId = null
		this.validarSelecaoAtual()
	}

	async carregarGrupoDaLoja() {
		if (!this.lojaId) {
			this.grupoEconomicoDaLojaId = null
			return
		}
		try {
			const loja = await this.findLojaUseCase.findLojaById(this.lojaId)
			this.grupoEconomicoDaLojaId = loja.grupoEconomico ? loja.grupoEconomico.id : null
		} catch (error: any) {
			this.grupoEconomicoDaLojaId = null
		}
	}

	validarSelecaoAtual() {
		if (!this.selectedId) return
		const acao = this.acoesDeCashback.find(a => a.id === this.selectedId)
		const grupoDaAcaoId = acao && acao.grupoEconomico ? acao.grupoEconomico.id : null
		if (this.grupoEconomicoAlvoId && grupoDaAcaoId && grupoDaAcaoId !== this.grupoEconomicoAlvoId) {
			this.selectedId = null
		}
	}

	@Watch('search')
	@Watch('type')
	onFiltrosDaListaDeAcoesChange() {
		this.paginaAcoes = 1
	}

	@Watch('showInactive')
	onShowInactiveChange() {
		this.carregarAcoes()
	}

	@Watch('grupoEconomicoFiltro')
	onGrupoEconomicoFiltroChange() {
		this.carregarAcoes()
	}

	async carregarAcoes() {
		try {
			this.carregandoAcoes = true
			const inativos = this.showInactive
			const grupoEconomicoId = this.grupoEconomicoFiltro ? this.grupoEconomicoFiltro.id : undefined
			const primeiraPagina = await this.findCashbackUseCase.findAcoesDeCashback({ page: 0, size: 50, inativos, grupoEconomicoId })
			const acoesPorId = new Map<string, AcaoDeCashback>()
			primeiraPagina.content.forEach(acao => acoesPorId.set(acao.id, acao))

			if (primeiraPagina.totalPages > 1) {
				const requisicoes: Promise<Page<AcaoDeCashback>>[] = []
				for (let pagina = 1; pagina < primeiraPagina.totalPages; pagina++) {
					requisicoes.push(this.findCashbackUseCase.findAcoesDeCashback({ page: pagina, size: 50, inativos, grupoEconomicoId }))
				}
				const paginas = await Promise.all(requisicoes)
				paginas.forEach(pagina => pagina.content.forEach(acao => acoesPorId.set(acao.id, acao)))
			}

			this.acoesDeCashback = [...acoesPorId.values()]
			this.paginaAcoes = 1
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoAcoes = false
		}
	}

	get linhasDeAcoes(): LinhaDeAcao[] {
		return this.acoesDeCashback.map(acao => ({
			id: acao.id,
			name: acao.nomeAcao,
			desc: acao.descricao,
			start: acao.dataInicio ? dateToPtBrFormat(moment(acao.dataInicio).subtract(3, 'hours').toDate()) : '- -',
			end: acao.dataFim ? dateToPtBrFormat(moment(acao.dataFim).subtract(3, 'hours').toDate()) : '- -',
			type: acao.acaoManutencaoDeCashback === 'Dobro de Cashback' ? 'dobro' : 'data',
			active: acao.dataFim ? moment(acao.dataFim).subtract(3, 'hours').isSameOrAfter(moment(), 'day') : true,
			used: !!acao.utilizada,
		}))
	}

	get filteredRows(): LinhaDeAcao[] {
		const q = this.search.trim().toLowerCase()
		return this.linhasDeAcoes.filter(r => {
			if (this.type !== 'todos' && r.type !== this.type) return false
			if (q && !(r.name.toLowerCase().includes(q) || r.desc.toLowerCase().includes(q))) return false
			return true
		})
	}

	get countLabel() {
		const n = this.filteredRows.length
		return n + (n === 1 ? ' ação' : ' ações')
	}

	get totalPaginasAcoes(): number {
		return Math.ceil(this.filteredRows.length / this.acoesPorPagina) || 1
	}

	get acoesPaginadas(): LinhaDeAcao[] {
		const inicio = (this.paginaAcoes - 1) * this.acoesPorPagina
		return this.filteredRows.slice(inicio, inicio + this.acoesPorPagina)
	}

	@Watch('acoesPaginadas')
	onAcoesPaginadasChange() {
		this.carregarMetas()
	}

	async carregarMetas() {
		const acaoIds = this.acoesPaginadas.map(acao => acao.id)
		if (acaoIds.length === 0) {
			this.metasPorAcao = {}
			return
		}
		try {
			const resumos = await this.findCashbackUseCase.findMetasDasAcoesDeCashback(acaoIds)
			const metas: Record<string, ResumoDaMetaDeAcaoDeCashback> = {}
			resumos.forEach(resumo => { metas[resumo.acaoDeCashbackId] = resumo })
			this.metasPorAcao = metas
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	percentualDaMeta(resumo: ResumoDaMetaDeAcaoDeCashback): number {
		if (!resumo.valorMeta) return 0
		return Math.round((resumo.valorAtingido / resumo.valorMeta) * 100)
	}

	valorDaMetaSemCentavos(resumo: ResumoDaMetaDeAcaoDeCashback): string {
		return (resumo.valorMeta || 0).toLocaleString('pt-BR', { maximumFractionDigits: 0 })
	}

	corDoProgresso(resumo: ResumoDaMetaDeAcaoDeCashback): string {
		const percentual = this.percentualDaMeta(resumo)
		if (percentual >= 100) return '#1e7d46'
		if (percentual >= 50) return '#e69138'
		return '#c62828'
	}

	@Watch('totalPaginasAcoes')
	onTotalPaginasAcoesChange(total: number) {
		if (this.paginaAcoes > total) this.paginaAcoes = total
	}

	get selectedItem(): AcaoDeCashback | null {
		return this.acoesDeCashback.find(a => a.id === this.selectedId) || null
	}

	classeDaLinhaDeAcao(item: LinhaDeAcao) {
		return {
			'cb-row-selecionada': item.id === this.selectedId,
			'cb-row-inativa': !item.active,
		}
	}

	selecionarAcao(id: string) {
		if (this.selectedId === id) {
			this.selectedId = null
			return
		}

		const acao = this.acoesDeCashback.find(a => a.id === id)
		const grupoDaAcaoId = acao && acao.grupoEconomico ? acao.grupoEconomico.id : null

		if (this.grupoEconomicoAlvoId && grupoDaAcaoId && grupoDaAcaoId !== this.grupoEconomicoAlvoId) {
			AlertModule.setError('A ação selecionada pertence a outro grupo econômico. Use uma ação do mesmo grupo econômico do filtro ou da loja selecionada para buscar os cashbacks.')
			return
		}

		this.selectedId = id
	}

	abrirDashboardDaAcao(item: LinhaDeAcao) {
		this.dashboardDaAcaoDeCashback.mostrar({
			id: item.id,
			tipo: item.type === 'dobro' ? 'dobro' : 'data',
			nome: item.name,
			descricao: item.desc,
			periodo: `${item.start} – ${item.end}`,
			ativa: item.active,
			inicio: item.start,
			fim: item.end,
		})
	}

	abrirDialogoDeCriarAcaoDeCashback() {
		try {
			if (!this.temRecurso('criar', 'acoes-de-manutencao-de-cashback'))
				throw new Error('Necessário permissão para criar')
			const novaAcao = {
				id: '',
				grupoEconomico: null,
				nomeAcao: '',
				descricao: '',
				dataInicio: '',
				dataFim: '',
			} as AcaoDeCashback
			this.dialogoDeEdicaoDeAcaoDeCashback.mostrar(novaAcao, false)
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	abrirDialogoDeEditarAcaoDeCashback(id: string) {
		try {
			if (!this.temRecurso('alterar', 'acoes-de-manutencao-de-cashback'))
				throw new Error('Necessário permissão para editar')
			const acao = this.acoesDeCashback.find(a => a.id === id)
			if (!acao) return
			this.dialogoDeEdicaoDeAcaoDeCashback.mostrar(acao, true)
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	abrirDialogoDeMetaDaAcao(item: LinhaDeAcao) {
		try {
			if (!item.used) return
			if (!this.temRecurso('alterar', 'acoes-de-manutencao-de-cashback'))
				throw new Error('Necessário permissão para editar')
			this.dialogoDeMetaDaAcaoDeCashback.mostrar(item.id, item.name)
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async excluirAcao(row: LinhaDeAcao) {
		const confirmado = await this.confirmacaoExclusao.mostrarComParametros(
			'Excluir ação?',
			`A ação <strong>${row.name}</strong> será removida permanentemente. Só é possível excluir ações que ainda não foram utilizadas em cashbacks.`,
		)
		if (!confirmado) return
		try {
			this.excluindo = true
			await this.saveCashbackUseCase.excluirAcaoDeCashback(row.id)
			if (this.selectedId === row.id) this.selectedId = null
			AlertModule.setSuccess('Ação excluída com sucesso')
			await this.carregarAcoes()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.excluindo = false
		}
	}

	gerarDataHora(data?: string | null, hora?: string | null): string | undefined {
		return moment(`${data} ${hora}`, 'YYYY-MM-DD HH:mm').toISOString(true)
	}

	get clientesPaginados(): ClienteComCashback[] {
		const inicio = (this.paginaClientes - 1) * this.clientesPorPagina
		return this.clients.slice(inicio, inicio + this.clientesPorPagina)
	}

	get totalPaginasClientes(): number {
		return Math.ceil(this.clients.length / this.clientesPorPagina)
	}

	async buscar() {
		if (this.cancelToken) this.cancelToken.cancel()
		if (!this.dataInicio || !this.dataFinal) return

		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()
			const config = { cancelToken: this.cancelToken.token }
			const baseParams = {
				cpfOuCnpj: this.cnpjCpfDoCliente || null,
				dataInicio: this.gerarDataHora(this.dataInicio, '00:00'),
				dataFinal: this.gerarDataHora(this.dataFinal, '23:59'),
				lojaId: this.lojaId,
				tipos: ['Cashback'],
				grupoEconomicoId: this.grupoEconomico?.id,
				filtrarPorDataDeCompra: this.basis === 'compra',
				sort: 'expiracao,asc',
			}
			const tamanhoMaximoDaPagina = 2000

			const primeiraPagina = await this.voucherService.findVouchers({ ...baseParams, page: 0, size: tamanhoMaximoDaPagina }, config)
			const vouchersPorId = new Map<string, Voucher>()
			primeiraPagina.content.forEach(voucher => vouchersPorId.set(voucher.id, voucher))

			if (primeiraPagina.totalPages > 1) {
				const requisicoes: Promise<Page<Voucher>>[] = []
				for (let p = 1; p < primeiraPagina.totalPages; p++) {
					requisicoes.push(this.voucherService.findVouchers({ ...baseParams, page: p, size: tamanhoMaximoDaPagina }, config))
				}
				const paginas = await Promise.all(requisicoes)
				paginas.forEach(pagina => pagina.content.forEach(voucher => vouchersPorId.set(voucher.id, voucher)))
			}

			this.totalRegistros = primeiraPagina.totalElements
			this.listaDeCashback = [...vouchersPorId.values()]
			this.paginaDetalhe = {}
			this.clientesExpandidos = []
			this.paginaClientes = 1
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	get clients(): ClienteComCashback[] {
		const mapa = new Map<string, ClienteComCashback>()
		this.listaDeCashback.forEach(voucher => {
			const cpfRaw = voucher.cliente?.cnpjOuCpf ?? ''
			let cliente = mapa.get(cpfRaw)
			if (!cliente) {
				cliente = {
					name: voucher.cliente?.razaoSocialOuNome ?? 'Sem cliente',
					cpf: aplicarMascaraParaCpfOuCnpjOculto(cpfRaw),
					cpfCompleto: cpfRaw,
					items: [],
				}
				mapa.set(cpfRaw, cliente)
			}
			cliente.items.push({
				gerado: this.formatarDataHora(voucher.dataHoraGeracao),
				vencimento: this.formatarDataHora(voucher.expiracao),
				valor: voucher.valor,
			})
		})
		return Array.from(mapa.values())
	}

	get resultLabel() {
		const n = this.clients.length
		const t = this.clients.reduce((a, c) => a + c.items.length, 0)
		return n + (n === 1 ? ' cliente · ' : ' clientes · ') + t + (t === 1 ? ' cashback' : ' cashbacks')
	}

	get grandTotal() {
		return this.fmt(this.clients.reduce((a, c) => a + this.clientTotal(c), 0))
	}

	fmt(n: number) {
		return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
	}

	formatarDataHora(data: Date | string | null | undefined): string {
		if (!data) return '- -'
		return moment(data).subtract(3, 'hours').format('DD/MM/YYYY [às] HH:mm:ss')
	}

	clientTotal(c: ClienteComCashback) { return c.items.reduce((a, i) => a + i.valor, 0) }

	itensPaginadosDoCliente(c: ClienteComCashback): ItemDeCashback[] {
		const pagina = this.paginaDetalhe[c.cpf] || 1
		const inicio = (pagina - 1) * this.detalheItensPorPagina
		return c.items.slice(inicio, inicio + this.detalheItensPorPagina)
	}

	totalPaginasDetalhe(c: ClienteComCashback): number {
		return Math.ceil(c.items.length / this.detalheItensPorPagina)
	}

	mudarPaginaDetalhe(cpf: string, pagina: number) {
		this.$set(this.paginaDetalhe, cpf, pagina)
	}

	abrirDialogoDePendentesDeDisparo() {
		if (this.cancelToken) this.cancelToken.cancel()
		const params = {
			cpfOuCnpj: this.cnpjCpfDoCliente || null,
			lojaId: this.lojaId,
			tipos: ['Cashback'],
			grupoEconomicoId: this.grupoEconomico?.id || null,
		}
		this.dialogoDePendentesDeDisparo.mostrar(params)
	}

	async aplicar() {
		if (!this.selectedItem || this.atualizandoCashback) return
		if (!this.usuario) return
		if (!this.dataInicio || !this.dataFinal) {
			AlertModule.setError('Informe o período (datas) para aplicar a manutenção')
			return
		}

		const incluirPendentesDeAtivacao = this.basis === 'compra' && this.form.pendentes

		if (!await this.possuiCashbacksParaManutencao(incluirPendentesDeAtivacao)) return

		if (incluirPendentesDeAtivacao) {
			const confirmado = await this.confirmacaoGeracaoPendentes.mostrar()
			if (!confirmado) return
		}

		const acao = this.selectedItem
		const command = {
			cpfOuCnpj: this.cnpjCpfDoCliente || null,
			dataInicio: this.gerarDataHora(this.dataInicio, '00:00'),
			dataFinal: this.gerarDataHora(this.dataFinal, '23:59'),
			acaoDeCashbackId: acao.id || null,
			tipos: ['Cashback'],
			lojaId: this.lojaId,
			grupoEconomicoId: this.grupoEconomico?.id,
			filtrarPorDataDeCompra: this.basis === 'compra',
			incluirPendentesDeAtivacao,
		}

		try {
			this.atualizandoCashback = true
			if (acao.acaoManutencaoDeCashback === 'Dobro de Cashback') {
				await this.voucherService.dobraVoucherEmMassa(command)
			} else {
				if (!this.permiteAbrirDiversosProcessosDeImportacao) {
					const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario)
					if (!possuiProcessoEmAberto) {
						AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!')
						return
					}
				}
				await this.voucherService.updateVoucherEmMassa(command)
			}
			AlertModule.setInfo('Atualização em andamento. Você receberá uma notificação assim que a atualização for concluída')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.atualizandoCashback = false
		}
	}

	async possuiCashbacksParaManutencao(incluirPendentesDeAtivacao: boolean): Promise<boolean> {
		if (this.listaDeCashback.length > 0) return true

		if (incluirPendentesDeAtivacao) {
			try {
				const pendentes = await this.carregarPendentesDeAtivacao()
				if (pendentes.length > 0) return true
			} catch (error: any) {
				AlertModule.setError(error)
				return false
			}
		}

		AlertModule.setError('Nenhum cashback encontrado para os filtros informados. Faça a busca e confira o resultado antes de aplicar a manutenção')
		return false
	}

	async exportarCsvDeCashbacksBuscados() {
		try {
			this.exportandoPesquisa = true
			const pendentes = await this.carregarPendentesDeAtivacao()
			const rows = [['Origem', 'Cliente', 'CPF/CNPJ', 'Gerado', 'Vencimento', 'Valor']]
			this.clients.forEach(c => c.items.forEach(i =>
				rows.push(['Cashback', c.name, c.cpfCompleto, i.gerado, i.vencimento, i.valor.toFixed(2).replace('.', ',')])))
			pendentes.forEach(p =>
				rows.push(['Pendente de ativação', p.name, p.cpf, p.gerado, '- -', p.valor.toFixed(2).replace('.', ',')]))
			this.download(rows, 'cashbacks-pesquisa.csv')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.exportandoPesquisa = false
		}
	}

	async exportarCsvDePreviaDaManutencao() {
		if (!this.selectedItem) return
		const acao = this.selectedItem

		try {
			this.exportandoPrevia = true
			const pendentes = await this.carregarPendentesDeAtivacao()
			const novoVencimento = acao.dataFim ? this.formatarDataHora(acao.dataFim) : '- -'

			if (acao.acaoManutencaoDeCashback === 'Dobro de Cashback') {
				const rows = [['Origem', 'Cliente', 'CPF/CNPJ', 'Gerado', 'Vencimento atual', 'Vencimento após ação', 'Valor atual', 'Valor após dobro']]
				this.clients.forEach(c => c.items.forEach(i =>
					rows.push(['Cashback', c.name, c.cpfCompleto, i.gerado, i.vencimento, novoVencimento,
						i.valor.toFixed(2).replace('.', ','), (i.valor * 2).toFixed(2).replace('.', ',')])))
				pendentes.forEach(p =>
					rows.push(['Pendente de ativação', p.name, p.cpf, p.gerado, '- -', novoVencimento,
						p.valor.toFixed(2).replace('.', ','), (p.valor * 2).toFixed(2).replace('.', ',')]))
				this.download(rows, 'previa-manutencao-dobro.csv')
				return
			}

			const rows = [['Origem', 'Cliente', 'CPF/CNPJ', 'Gerado', 'Vencimento atual', 'Novo vencimento', 'Valor']]
			this.clients.forEach(c => c.items.forEach(i =>
				rows.push(['Cashback', c.name, c.cpfCompleto, i.gerado, i.vencimento, novoVencimento, i.valor.toFixed(2).replace('.', ',')])))
			pendentes.forEach(p =>
				rows.push(['Pendente de ativação', p.name, p.cpf, p.gerado, '- -', novoVencimento, p.valor.toFixed(2).replace('.', ',')]))
			this.download(rows, 'previa-manutencao-alteracao-data.csv')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.exportandoPrevia = false
		}
	}

	async exportarCsvAgrupadoDaAcao() {
		if (!this.selectedItem) return
		const acao = this.selectedItem

		const command = {
			cpfOuCnpj: this.cnpjCpfDoCliente || null,
			dataInicio: this.gerarDataHora(this.dataInicio, '00:00'),
			dataFinal: this.gerarDataHora(this.dataFinal, '23:59'),
			acaoDeCashbackId: acao.id || null,
			tipos: ['Cashback'],
			lojaId: this.lojaId,
			grupoEconomicoId: this.grupoEconomico?.id,
			filtrarPorDataDeCompra: this.basis === 'compra',
			incluirPendentesDeAtivacao: this.form.pendentes,
		}

		try {
			this.exportandoAgrupado = true
			const cashbacks = await this.voucherService.findCashbacksAgrupadosParaManutencao(command)
			if (!cashbacks || !cashbacks.length) {
				AlertModule.setInfo('Nenhum cashback encontrado para os filtros informados')
				return
			}

			const dobro = acao.acaoManutencaoDeCashback === 'Dobro de Cashback'
			const novoVencimento = acao.dataFim ? this.formatarDataHora(acao.dataFim) : '- -'
			const rows = [['Loja', 'Cliente', 'CPF/CNPJ', 'Telefones', 'Novo vencimento', 'Valor total']]
			cashbacks.forEach(cashback => rows.push([
				cashback.nomeLoja || 'Sem loja',
				cashback.nomeCliente,
				cashback.cpfCnpj || '',
				cashback.telefones || '',
				novoVencimento,
				((cashback.valorTotal || 0) * (dobro ? 2 : 1)).toFixed(2).replace('.', ','),
			]))
			this.download(rows, 'cashbacks-acao-por-cliente.csv')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.exportandoAgrupado = false
		}
	}

	download(rows: string[][], filename: string) {
		const csv = rows.map(r => r.map(f => '"' + String(f).replace(/"/g, '""') + '"').join(';')).join('\r\n')
		const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' })
		const url = URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = url; a.download = filename; a.click()
		URL.revokeObjectURL(url)
	}

	async carregarPendentesDeAtivacao(): Promise<ItemDeCashbackPendente[]> {
		if (!this.form.pendentes) return []
		const params = {
			cpfOuCnpj: this.cnpjCpfDoCliente || null,
			dataInicio: this.gerarDataHora(this.dataInicio, '00:00'),
			dataFinal: this.gerarDataHora(this.dataFinal, '23:59'),
			lojaId: this.lojaId,
			grupoEconomicoId: this.grupoEconomico?.id,
		}
		const cashbacks = await this.findCashbackUseCase.findCashbacksPendentesDeAtivacao(params)
		const linhas: ItemDeCashbackPendente[] = []
		cashbacks.forEach(cashback => {
			const valoresDosItens = cashback.itensCashback && cashback.itensCashback.length > 0
				? cashback.itensCashback.map(item => item.valorCreditado || 0)
				: [cashback.valorTotalCreditado || 0]

			valoresDosItens.forEach(valor => linhas.push({
				name: cashback.cliente ? cashback.cliente.razaoSocialOuNome : 'Sem cliente',
				cpf: cashback.cliente ? cashback.cliente.cnpjOuCpf : '',
				gerado: this.formatarDataHora(cashback.dataHora),
				valor,
			}))
		})
		return linhas
	}
}
